module.exports = __webpack_public_path__ + "static/img/ad3-1.1d97cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad3-1.png
// module id = rMTt
// module chunks = 12